var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-card"},[(_vm.rowIndex)?_c('div',{staticClass:"row-index"},[_vm._v(_vm._s(_vm.rowIndex))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }